<template>
  <footer class="main-footer">
    <div class="info-merch">
      <div class="merch-text">
        <h3>MERCHANDISE</h3>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="179.604"
          height="6.927"
          viewBox="0 0 179.604 6.927"
          class="divider"
        >
          <g id="Divider" transform="translate(0.5 1.51)">
            <path
              id="Union_43"
              data-name="Union 43"
              d="M129.189-341.5h6.71l-1.157,2.735-4,1.536C130.2-338.715,129.757-339.938,129.189-341.5Zm93.884,3.834a4.471,4.471,0,0,0-2.332-.187,16.212,16.212,0,0,1-4.253.285c-.547-.011-1.1-.022-1.636-.012a50.712,50.712,0,0,1-5.487-.031,9.551,9.551,0,0,0-1.779.061c-1.348.129-2.7.258-3.86-.878-1.306,1.078-2.782.975-4.253.872a13.479,13.479,0,0,0-1.763-.047c-1.989.123-3.991.027-5.988.027h-6.489c-2,0-4,.077-5.989-.022-1.756-.086-3.5-.514-5.251-.519-1.633-.005-3.265.424-4.9.521-1.659.1-3.327.021-4.991.021h-5.674c-.577-1.332-1.005-2.318-1.546-3.567.661-.2,1.2-.367,1.717-.527l1.176,2.478c.193-.962.286-1.418.431-2.136h76.028c-.486.546-.817.917-1.331,1.492.338.574.715,1.212,1.167,1.984-.5.1-1.027.383-1.393.245-2.244-.847-4.4-1.6-6.711-.026a1.928,1.928,0,0,1-1.259.087,2.766,2.766,0,0,0-1.182.014,2.689,2.689,0,0,1-.88.143A6.078,6.078,0,0,1,223.073-337.67Zm-114.455.059c-.4-.08-.712-.618-1.065-.943l-.97.97-1.657-3.253c.253-.3.355-.533.458-.533,4.416-.018,8.832-.016,13.769-.016-.4.535-.686.916-.962,1.284.277.476.582,1,.886,1.523a18.218,18.218,0,0,0-4.614.558,20.337,20.337,0,0,1-4.131.571A8.811,8.811,0,0,1,108.618-337.611Zm145.31-.536a3.293,3.293,0,0,0-2.295-.388c-1.218.173-2.384.826-3.592.889a2.987,2.987,0,0,1-.921-.142,2.451,2.451,0,0,0-1.809.062c-1.525.664-3.223-.259-4.269-1.905a9.941,9.941,0,0,0-2.091-1.753h36.669l1.563,2.481a38.046,38.046,0,0,0-5.147.929,4.628,4.628,0,0,1-4.63-.469c-1.955.995-1.955.995-4.557-.183-.46.327-1.227,1.112-1.438.983-1.147-.7-2.351-.41-3.555-.122a8.508,8.508,0,0,1-1.946.312A3.014,3.014,0,0,1,253.928-338.147Zm-104.949.429a3.769,3.769,0,0,0-2.232-.129,7.247,7.247,0,0,1-5.5-.572c-1.266-.578-3.228.368-5.12.67l2.525-3.657H151.8a9.363,9.363,0,0,0-.172,1.853,6.6,6.6,0,0,0,.492,1.489,2.623,2.623,0,0,1-1.675.6A5.86,5.86,0,0,1,148.979-337.718Zm4.08-1.449c1.91-.961,3.017-.227,4.038,1.178a3.543,3.543,0,0,1-1.58.435A3.116,3.116,0,0,1,153.059-339.167Zm-32.98.589c.76-2.24,2.873-2.272,5.143-3.415l-1.13,2.388.078-.078.817.7-.315.316-.7-.817.053-.053-2.474,1.8Zm-1,0h1q-.335.416-.671.829Q119.243-338.162,119.077-338.578Zm8.265-.5c0-.391.105-.707.236-.707s.236.317.236.707-.106.706-.236.706S127.342-338.687,127.342-339.078Zm-27.265.234v-2.533l2.826-.257v2.789Zm137.146-1.734c0-.781.158-1.414.354-1.414s.354.633.354,1.414-.158,1.415-.354,1.415S237.224-339.8,237.224-340.578Zm39.887-.4c-.021-.143.356-.342,1.121-1.021-.346,1.217-.517,1.819-.689,2.422A8.248,8.248,0,0,1,277.111-340.979Zm-123.241-.1c0-.13.317-.236.707-.236s.707.105.707.236-.316.235-.707.235S153.87-340.948,153.87-341.078Z"
              transform="translate(-100.077 342)"
            />
          </g>
        </svg>
        <p>
          Discover the official DayZ merchandise:
          <span>T-shirts, hoodies and more</span>
        </p>
        <a
          href="https://store.bistudio.com/collections/dayz"
          class="footer-btn-wrapper"
        >
          <svg
            class="bi-logo-footer"
            xmlns="http://www.w3.org/2000/svg"
            width="109.513"
            height="38.593"
            viewBox="0 0 109.513 38.593"
          >
            <path
              id="Union_45"
              data-name="Union 45"
              d="M110-460.028h-.148a10.084,10.084,0,0,1-8.117-3.49A8.359,8.359,0,0,1,100-468.264l.8.739a6.765,6.765,0,0,0,1.665,3.15c1.841,2.071,4.807,3.034,8.127,2.849,1.064-2.908,2.4-6.544,3.7-10.074a37.27,37.27,0,0,0-7.181,1.4l2.462-3.423h5.458c1.655-4.493,3.133-8.528,3.754-10.249.157-.447.325-.894.482-1.351h-.838a18.561,18.561,0,0,0-10.156,4.016,16.749,16.749,0,0,0-4.6,5.415H101.7a18.261,18.261,0,0,1,5.683-6.553,19.959,19.959,0,0,1,10.975-4.317,13.43,13.43,0,0,1,1.4,0c1.36-3.967,2.492-7.6,2.492-7.6h2.374l-3.1,7.779a9.255,9.255,0,0,1,5.724,3.326c1.93,2.441,2.374,5.766,1.261,9.354l-.059.176,8.167.039-.769,1.079h-7.841a20.192,20.192,0,0,1-6.443,8.168,20.145,20.145,0,0,1-10.678,4.278l-1.468,3.647-.985.749Zm5.605-11.7-4.078,10.142a18.84,18.84,0,0,0,9.161-3.89,19.132,19.132,0,0,0,5.753-6.961C121.958-472.309,118.392-472.036,115.6-471.726Zm.769-1.905h10.521c.068-.194.138-.4.2-.593.985-3.131.64-5.989-.986-8.06a8.008,8.008,0,0,0-5.123-2.811Zm66.932,5.511a5.561,5.561,0,0,1-1.768-1.216,5.638,5.638,0,0,1-1.184-1.792,5.615,5.615,0,0,1-.424-2.184,5.61,5.61,0,0,1,.424-2.183,5.629,5.629,0,0,1,1.184-1.792A5.456,5.456,0,0,1,183.3-478.5a5.468,5.468,0,0,1,2.176-.432,5.468,5.468,0,0,1,2.176.432,5.465,5.465,0,0,1,1.768,1.209,5.629,5.629,0,0,1,1.184,1.792,5.61,5.61,0,0,1,.424,2.183,5.615,5.615,0,0,1-.424,2.184,5.638,5.638,0,0,1-1.184,1.792,5.571,5.571,0,0,1-1.768,1.216,5.381,5.381,0,0,1-2.176.44A5.381,5.381,0,0,1,183.3-468.121Zm.344-8.472a3.38,3.38,0,0,0-1.192,1.36,4.2,4.2,0,0,0-.416,1.872,4.207,4.207,0,0,0,.416,1.864,3.484,3.484,0,0,0,1.192,1.384,3.18,3.18,0,0,0,1.832.528,3.143,3.143,0,0,0,1.824-.528A3.579,3.579,0,0,0,188.5-471.5a4.14,4.14,0,0,0,.424-1.864,4.2,4.2,0,0,0-.416-1.872,3.382,3.382,0,0,0-1.193-1.36,3.249,3.249,0,0,0-1.831-.512A3.254,3.254,0,0,0,183.649-476.592ZM164.081-468a5.06,5.06,0,0,1-1.376-.792,6.535,6.535,0,0,1-.9-.888l1.408-1.3q.273.288.64.624a3.481,3.481,0,0,0,.88.576,2.759,2.759,0,0,0,1.184.24,1.949,1.949,0,0,0,1.4-.44,1.389,1.389,0,0,0,.456-1.032,1.23,1.23,0,0,0-.56-1.072,5.681,5.681,0,0,0-2-.656,3.972,3.972,0,0,1-1.607-.656,2.969,2.969,0,0,1-.944-1.111,3.082,3.082,0,0,1-.312-1.352,2.929,2.929,0,0,1,.409-1.512,2.985,2.985,0,0,1,1.231-1.129,4.438,4.438,0,0,1,2.073-.432,5.066,5.066,0,0,1,1.455.185,3.972,3.972,0,0,1,1.016.448,3.177,3.177,0,0,1,.633.511c.148.166.256.286.32.361l-1.327,1.247q-.1-.1-.376-.336a3.026,3.026,0,0,0-.72-.44,2.562,2.562,0,0,0-1.064-.2,1.649,1.649,0,0,0-1.224.4,1.16,1.16,0,0,0-.392.8,1.12,1.12,0,0,0,.456.92,4.591,4.591,0,0,0,1.768.633,5.775,5.775,0,0,1,1.56.568,3.148,3.148,0,0,1,1.176,1.088,3.238,3.238,0,0,1,.448,1.784,2.953,2.953,0,0,1-.5,1.672,3.439,3.439,0,0,1-1.368,1.175,4.393,4.393,0,0,1-1.976.432A5.04,5.04,0,0,1,164.081-468Zm38.152.031v-10.672h6.912v1.777h-4.9v2.512h3.6v1.792h-3.6v2.784h5.264v1.808Zm-3.76,0-2.16-4.208h-1.519v4.208h-1.937v-10.672h3.536a4.319,4.319,0,0,1,1.713.3,3.221,3.221,0,0,1,1.136.784,3.139,3.139,0,0,1,.632,1.032,3.121,3.121,0,0,1,.2,1.064,3.5,3.5,0,0,1-.448,1.784,3.194,3.194,0,0,1-1.344,1.24l2.464,4.464Zm-3.679-5.872h1.615a1.564,1.564,0,0,0,1.193-.448,1.526,1.526,0,0,0,.424-1.088,1.485,1.485,0,0,0-.448-1.12,1.613,1.613,0,0,0-1.168-.432h-1.615Zm-20.688,5.872v-8.9h-3.616v-1.777h9.248v1.777h-3.616v8.9Zm-18.833,0v-10.672h2.016v10.672Zm-9.536,0v-10.672H149.4a4.4,4.4,0,0,1,1.9.368,2.689,2.689,0,0,1,1.159,1,2.631,2.631,0,0,1,.392,1.417,2.229,2.229,0,0,1-.2.976,2.322,2.322,0,0,1-.488.689,2.544,2.544,0,0,1-.569.416,1.051,1.051,0,0,1-.439.144,2.893,2.893,0,0,1,.671.175,2.446,2.446,0,0,1,.736.448,2.377,2.377,0,0,1,.584.792,2.762,2.762,0,0,1,.232,1.193,2.882,2.882,0,0,1-.52,1.808,2.834,2.834,0,0,1-1.424.959,6.723,6.723,0,0,1-2.04.288Zm1.936-1.712h1.712a5.415,5.415,0,0,0,.632-.041,2.121,2.121,0,0,0,.656-.184,1.22,1.22,0,0,0,.512-.448,1.466,1.466,0,0,0,.2-.815,1.314,1.314,0,0,0-.328-.968,1.7,1.7,0,0,0-.792-.448,3.517,3.517,0,0,0-.88-.12h-1.712Zm0-4.7H149.3a2.195,2.195,0,0,0,1.112-.288,1.062,1.062,0,0,0,.5-1.008,1.067,1.067,0,0,0-.248-.76,1.374,1.374,0,0,0-.616-.376,2.569,2.569,0,0,0-.752-.112h-1.632Z"
              transform="translate(-100 494.265)"
            />
          </svg>
          <Hover class="hover" />
          <svg
            class="btn-background"
            xmlns="http://www.w3.org/2000/svg"
            width="160.09"
            height="59.45"
            viewBox="0 0 160.09 59.45"
          >
            <path
              id="Path_2303"
              data-name="Path 2303"
              d="M160,15.448h.09V10.2a3.105,3.105,0,0,0-1.311-2.069c-.605-.385-.71-.762-.542-1.965a8.12,8.12,0,0,0-.322-3.076,3.927,3.927,0,0,0-.568-1.251h-4.928l-.174.231c-.2-.167-.385-.252-.49-.193a.607.607,0,0,0-.215.205,7.692,7.692,0,0,0-3.566.754c-.506.287-.762-.209-1.064-.794-.035-.067-.07-.136-.106-.2h-.165A2.639,2.639,0,0,0,144.472.42H8.263l-.01.025c-.219.617-.051,1.1.724,2.078,1.114,1.408,1.289,2.208.48,2.208-.29,0-.528-.174-.528-.385C8.93,3.814,5.917.839,5.41.839c-.645,0-2.225.173-1.993,1.679.081.529-.049.453-.306.3a.978.978,0,0,0-1.4.119c-.464.51-.241,1.8-.094,2.654a4.834,4.834,0,0,1,.094.7c-.019.655-.612.759-1.165.839C.171,7.189.04,7.973,0,8.977v2.774a34.376,34.376,0,0,0,.467,4.691c.245,1.673.441,3.008.151,3.345-.53.621-.666,2.8-.553,8.95.037,2.016.057,3.995.042,4.4-.032.944.294,7.406.436,8.647a3.594,3.594,0,0,0,.593,1.558c.59.739-.007,1.7-1.055,1.7l-.081,0V50.5a3.29,3.29,0,0,0,1.189,2.146c.549.4.643.791.492,2.038a9.577,9.577,0,0,0,.291,3.193,4.416,4.416,0,0,0,.515,1.3h4.47c.058-.088.11-.17.157-.239.184.173.349.26.445.2a.591.591,0,0,0,.2-.212,6.227,6.227,0,0,0,3.234-.783c.458-.3.691.218.964.824.031.069.217.841.25.912H147.4V58.455h3.58l.01-.025c.242-.595.058-1.059-.8-2-1.229-1.356-1.42-2.126-.53-2.126.32,0,.582.166.582.371,0,.512,3.323,3.379,3.882,3.379.711,0,2.453-.166,2.2-1.618-.09-.51.054-.436.338-.29a1.186,1.186,0,0,0,1.546-.113c.511-.493.266-1.737.1-2.559a3.98,3.98,0,0,1-.1-.677c.02-.631.675-.73,1.284-.808.411-.054.554-.81.6-1.776V47.536a28.979,28.979,0,0,0-.514-4.522c-.27-1.612-.486-2.9-.167-3.223.585-.6.734-2.7.609-8.625-.041-1.943-.062-3.85-.047-4.238.036-.912-.323-7.138-.48-8.334a3.236,3.236,0,0,0-.653-1.5C158.187,16.38,158.845,15.448,160,15.448ZM2.3,15.24c-.061-.539.031-.98.2-.98.531,0,.787.444.787,1.373C3.295,16.84,2.446,16.5,2.3,15.24ZM157.325,45.117c-.586,0-.867-.429-.867-1.325,0-1.161.935-.835,1.093.381C157.619,44.692,157.517,45.117,157.325,45.117Z"
              transform="translate(0 -0.42)"
            />
          </svg>
        </a>
      </div>
      <img
        class="merch"
        src="../../public/img/merch/dayz_merch_visual-min.png"
        alt=""
      />
    </div>
    <div class="social-form">
      <div class="social">
        <div class="social-wrapper">
          <h4>Follow DayZ</h4>
          <div class="social-icons">
            <a href="https://www.facebook.com/DayZ">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
              >
                <title>facebook</title>
                <path
                  d="M19 6h5v-6h-5c-3.86 0-7 3.14-7 7v3h-4v6h4v16h6v-16h5l1-6h-6v-3c0-0.542 0.458-1 1-1z"
                ></path>
              </svg>
            </a>
            <a href="https://x.com/dayz">
              <img
                style="height: 32px; width: 32px;"
                src="/img/logos/logo-white.png"
              />
              <!-- <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
              >
                <title>twitter</title>
                <path
                  d="M32 7.075c-1.175 0.525-2.444 0.875-3.769 1.031 1.356-0.813 2.394-2.1 2.887-3.631-1.269 0.75-2.675 1.3-4.169 1.594-1.2-1.275-2.906-2.069-4.794-2.069-3.625 0-6.563 2.938-6.563 6.563 0 0.512 0.056 1.012 0.169 1.494-5.456-0.275-10.294-2.888-13.531-6.862-0.563 0.969-0.887 2.1-0.887 3.3 0 2.275 1.156 4.287 2.919 5.463-1.075-0.031-2.087-0.331-2.975-0.819 0 0.025 0 0.056 0 0.081 0 3.181 2.263 5.838 5.269 6.437-0.55 0.15-1.131 0.231-1.731 0.231-0.425 0-0.831-0.044-1.237-0.119 0.838 2.606 3.263 4.506 6.131 4.563-2.25 1.762-5.075 2.813-8.156 2.813-0.531 0-1.050-0.031-1.569-0.094 2.913 1.869 6.362 2.95 10.069 2.95 12.075 0 18.681-10.006 18.681-18.681 0-0.287-0.006-0.569-0.019-0.85 1.281-0.919 2.394-2.075 3.275-3.394z"
                ></path>
              </svg> -->
            </a>
            <a href="https://www.youtube.com/user/DayZDevTeam">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
              >
                <title>youtube-play</title>
                <path
                  d="M11.109 17.625l7.562-3.906-7.562-3.953v7.859zM14 4.156c5.891 0 9.797 0.281 9.797 0.281 0.547 0.063 1.75 0.063 2.812 1.188 0 0 0.859 0.844 1.109 2.781 0.297 2.266 0.281 4.531 0.281 4.531v2.125s0.016 2.266-0.281 4.531c-0.25 1.922-1.109 2.781-1.109 2.781-1.062 1.109-2.266 1.109-2.812 1.172 0 0-3.906 0.297-9.797 0.297v0c-7.281-0.063-9.516-0.281-9.516-0.281-0.625-0.109-2.031-0.078-3.094-1.188 0 0-0.859-0.859-1.109-2.781-0.297-2.266-0.281-4.531-0.281-4.531v-2.125s-0.016-2.266 0.281-4.531c0.25-1.937 1.109-2.781 1.109-2.781 1.062-1.125 2.266-1.125 2.812-1.188 0 0 3.906-0.281 9.797-0.281v0z"
                ></path>
              </svg>
            </a>
            <a href="https://www.twitch.tv/dayz">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
              >
                <title>twitch</title>
                <path
                  d="M3 0l-3 5v23h8v4h4l4-4h5l9-9v-19h-27zM26 17l-5 5h-5l-4 4v-4h-6v-18h20v13z"
                ></path>
                <path d="M19 8h3v8h-3v-8z"></path>
                <path d="M13 8h3v8h-3v-8z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="form">
        <div class="header-text-form">
          <h4>Sign up for our mailing list</h4>
          <p>Be the first to know about any DayZ updates</p>
        </div>
        <form @submit.prevent="onSubmit">
          <div class="field-holder">
            <input
              class="email"
              v-validate="'required|email'"
              v-model="email_address"
              required
              type="email"
              name="email_address"
              id="email_address"
              placeholder="Enter your email address"
            />
          </div>
          <p v-if="error" class="newsletter-error">Something went wrong!</p>
          <p v-if="isDone" class="newsletter-success">
            Thank you for subscribing!
          </p>

          <div class="submit">
            <div class="terms">
              <input v-model="checked" type="checkbox" required name="terms" />
              <label for="terms">
                I agree with
                <a
                  target="_blank"
                  href="https://accounts.bistudio.com/terms-and-conditions"
                  >terms and conditions</a
                >
              </label>
            </div>
            <div class="submit-wrapper">
              <button>SIGN UP</button>
              <Hover class="hover" />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="160.09"
                height="59.45"
                class="submit-btn"
                viewBox="0 0 160.09 59.45"
              >
                <path
                  id="Path_2303"
                  data-name="Path 2303"
                  class="cls-1"
                  d="M160,15.448h.09V10.2a3.105,3.105,0,0,0-1.311-2.069c-.605-.385-.71-.762-.542-1.965a8.12,8.12,0,0,0-.322-3.076,3.927,3.927,0,0,0-.568-1.251h-4.928l-.174.231c-.2-.167-.385-.252-.49-.193a.607.607,0,0,0-.215.205,7.692,7.692,0,0,0-3.566.754c-.506.287-.762-.209-1.064-.794-.035-.067-.07-.136-.106-.2h-.165A2.639,2.639,0,0,0,144.472.42H8.263l-.01.025c-.219.617-.051,1.1.724,2.078,1.114,1.408,1.289,2.208.48,2.208-.29,0-.528-.174-.528-.385C8.93,3.814,5.917.839,5.41.839c-.645,0-2.225.173-1.993,1.679.081.529-.049.453-.306.3a.978.978,0,0,0-1.4.119c-.464.51-.241,1.8-.094,2.654a4.834,4.834,0,0,1,.094.7c-.019.655-.612.759-1.165.839C.171,7.189.04,7.973,0,8.977v2.774a34.376,34.376,0,0,0,.467,4.691c.245,1.673.441,3.008.151,3.345-.53.621-.666,2.8-.553,8.95.037,2.016.057,3.995.042,4.4-.032.944.294,7.406.436,8.647a3.594,3.594,0,0,0,.593,1.558c.59.739-.007,1.7-1.055,1.7l-.081,0V50.5a3.29,3.29,0,0,0,1.189,2.146c.549.4.643.791.492,2.038a9.577,9.577,0,0,0,.291,3.193,4.416,4.416,0,0,0,.515,1.3h4.47c.058-.088.11-.17.157-.239.184.173.349.26.445.2a.591.591,0,0,0,.2-.212,6.227,6.227,0,0,0,3.234-.783c.458-.3.691.218.964.824.031.069.217.841.25.912H147.4V58.455h3.58l.01-.025c.242-.595.058-1.059-.8-2-1.229-1.356-1.42-2.126-.53-2.126.32,0,.582.166.582.371,0,.512,3.323,3.379,3.882,3.379.711,0,2.453-.166,2.2-1.618-.09-.51.054-.436.338-.29a1.186,1.186,0,0,0,1.546-.113c.511-.493.266-1.737.1-2.559a3.98,3.98,0,0,1-.1-.677c.02-.631.675-.73,1.284-.808.411-.054.554-.81.6-1.776V47.536a28.979,28.979,0,0,0-.514-4.522c-.27-1.612-.486-2.9-.167-3.223.585-.6.734-2.7.609-8.625-.041-1.943-.062-3.85-.047-4.238.036-.912-.323-7.138-.48-8.334a3.236,3.236,0,0,0-.653-1.5C158.187,16.38,158.845,15.448,160,15.448ZM2.3,15.24c-.061-.539.031-.98.2-.98.531,0,.787.444.787,1.373C3.295,16.84,2.446,16.5,2.3,15.24ZM157.325,45.117c-.586,0-.867-.429-.867-1.325,0-1.161.935-.835,1.093.381C157.619,44.692,157.517,45.117,157.325,45.117Z"
                  transform="translate(0 -0.42)"
                />
              </svg>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="footer-info">
      <Container>
        <grid class="footer-info__logos">
          <grid-item>
            <a
              href="http://www.bistudio.com"
              title="Bohemia Interactive Website"
              target="_blank"
              rel="nofollow me noopener noreferrer"
            >
              <img
                src="https://static.bistudio.com/images/logos/bi_logo.svg"
                alt="Bohemia Interactive"
                width="153px"
              />
            </a>
          </grid-item>
          <template>
            <grid-item>
              <template>
                <a
                  href="http://www.pegi.info/en/index/id/33/"
                  target="_blank"
                  rel="nofollow me noopener noreferrer"
                >
                  <img
                    src="https://static.bistudio.com/images/ratings/pegi/18.svg"
                    alt="PEGI 18"
                    width="60px"
                    height="74px"
                  />
                </a>
              </template>
            </grid-item>
          </template>
        </grid>

        <div class="footer-info__links">
          <p class="footer-info__links-copyright">
            © {{ new Date().getFullYear() }} BOHEMIA INTERACTIVE a.s.
            {{ siteName }}
            <sup style="font-family: arial, Helvetica, sans-serif">&reg;</sup>
            and BOHEMIA INTERACTIVE<sup
              style="font-family: arial, Helvetica, sans-serif"
              >&reg;</sup
            >
            are registered trademarks of BOHEMIA INTERACTIVE a.s. All rights
            reserved. All other trademarks and copyrights are the property of
            their respective owners.
          </p>
          <ul class="footer-info__links-list list-inline">
            <li v-for="(link, index) in copyrightLinks" :key="index">
              <a :href="link.url">{{ link.name }}</a>
            </li>
            <li>
              <a
                class="footer-info__links-icon"
                href="https://www.facebook.com/BohemiaInteractive"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="follow bohemia interactive on facebook"
                v-html="facebook"
              ></a>
              <a
                class="footer-info__links-icon"
                href="https://twitter.com/bohemiainteract"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="follow bohemia interactive on twitter"
                v-html="twitter"
              ></a>
              <a
                class="footer-info__links-icon"
                href="https://www.youtube.com/user/BohemiaInteract"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="follow bohemia interactive on youtube"
                v-html="youtube"
              ></a>
            </li>
          </ul>
        </div>
      </Container>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import generateList from "../utils/iconListGenerator";
import { facebook, twitter, youtube } from "../utils/Socialicons";
import Container from "./common/Container";
import Hover from "../components/buy-buttons/Hover.vue";

export default {
  props: {
    siteName: {
      type: String,
      default: "DAYZ",
    },
    socialLinks: {
      type: [Array, Boolean],
    },
    copyrightLinks: {
      type: Array,
    },
  },
  components: {
    Container,
    Hover,
  },
  data() {
    return {
      email_address: "",
      checked: false,
      error: false,
      isDone: false,
    };
  },

  Buttondata() {
    return {
      facebook,
      twitter,
      youtube,
    };
  },
  computed: {
    ...mapGetters("settings", {
      rating: "rating",
    }),
    socialLinksList() {
      return this.generateList(this.socialLinks);
    },
  },
  methods: {
    generateList,
    async onSubmit() {
      const formData = new FormData();
      formData.append("mauticform[email_address]", this.email_address);
      formData.append("mauticform[formId]", "14");
      formData.append("mauticform[return]", window.location.href);
      formData.append("mauticform[formName]", "dayzsubsribeform");
      formData.append("mauticform[messenger]", "1");

      try {
        const response = await fetch(
          "https://mautic.bistudio.com/form/submit?formId=14",
          {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            },
            body: formData,
          }
        );
        if (!response.ok) {
          this.error = true;
        }
        this.isDone = true;
      } catch (error) {
        this.error = true;
      }
      this.email_address = "";
      this.checked = false;
      setTimeout(() => {
        this.error = false;
        this.isDone = false;
      }, 5000);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/styles/vars";
@import "../assets/styles/mixins";
@import url("https://p.typekit.net/p.css?s=1&k=jqh0fna&ht=tk&f=44989.44990.44991.44992.50019.50020.50023.50024.50025.50026&a=70143751&app=typekit&e=css");

@font-face {
  font-family: "poster-gothic-round-cond-atf";
  src: url("https://use.typekit.net/af/3f7764/00000000000000007735c6d6/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/3f7764/00000000000000007735c6d6/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
      format("woff"),
    url("https://use.typekit.net/af/3f7764/00000000000000007735c6d6/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
      format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 400;
  font-stretch: normal;
}

@font-face {
  font-family: "poster-gothic-round-cond-atf";
  src: url("https://use.typekit.net/af/d06368/00000000000000007735c6db/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/d06368/00000000000000007735c6db/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
      format("woff"),
    url("https://use.typekit.net/af/d06368/00000000000000007735c6db/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
      format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 500;
  font-stretch: normal;
}

@font-face {
  font-family: "poster-gothic-round-cond-atf";
  src: url("https://use.typekit.net/af/24075d/00000000000000007735c6e0/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/24075d/00000000000000007735c6e0/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3")
      format("woff"),
    url("https://use.typekit.net/af/24075d/00000000000000007735c6e0/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3")
      format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 600;
  font-stretch: normal;
}

@font-face {
  font-family: "poster-gothic-round-cond-atf";
  src: url("https://use.typekit.net/af/3f4e24/00000000000000007735c6e5/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/3f4e24/00000000000000007735c6e5/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
      format("woff"),
    url("https://use.typekit.net/af/3f4e24/00000000000000007735c6e5/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
      format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 700;
  font-stretch: normal;
}

@font-face {
  font-family: "new-frank";
  src: url("https://use.typekit.net/af/c3d910/00000000000000007735fdfd/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/c3d910/00000000000000007735fdfd/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
      format("woff"),
    url("https://use.typekit.net/af/c3d910/00000000000000007735fdfd/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3")
      format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 500;
  font-stretch: normal;
}

@font-face {
  font-family: "new-frank";
  src: url("https://use.typekit.net/af/0d311e/00000000000000007735fdfe/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/0d311e/00000000000000007735fdfe/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3")
      format("woff"),
    url("https://use.typekit.net/af/0d311e/00000000000000007735fdfe/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3")
      format("opentype");
  font-display: auto;
  font-style: italic;
  font-weight: 500;
  font-stretch: normal;
}

@font-face {
  font-family: "new-frank";
  src: url("https://use.typekit.net/af/f6dbae/00000000000000007735fe03/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/f6dbae/00000000000000007735fe03/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3")
      format("woff"),
    url("https://use.typekit.net/af/f6dbae/00000000000000007735fe03/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3")
      format("opentype");
  font-display: auto;
  font-style: italic;
  font-weight: 400;
  font-stretch: normal;
}

@font-face {
  font-family: "new-frank";
  src: url("https://use.typekit.net/af/9bc52f/00000000000000007735fe04/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/9bc52f/00000000000000007735fe04/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
      format("woff"),
    url("https://use.typekit.net/af/9bc52f/00000000000000007735fe04/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
      format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 400;
  font-stretch: normal;
}

@font-face {
  font-family: "new-frank";
  src: url("https://use.typekit.net/af/a0a470/00000000000000007735fe05/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/a0a470/00000000000000007735fe05/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
      format("woff"),
    url("https://use.typekit.net/af/a0a470/00000000000000007735fe05/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
      format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 700;
  font-stretch: normal;
}

@font-face {
  font-family: "new-frank";
  src: url("https://use.typekit.net/af/fc4e5f/00000000000000007735fe06/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3")
      format("woff2"),
    url("https://use.typekit.net/af/fc4e5f/00000000000000007735fe06/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3")
      format("woff"),
    url("https://use.typekit.net/af/fc4e5f/00000000000000007735fe06/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3")
      format("opentype");
  font-display: auto;
  font-style: italic;
  font-weight: 700;
  font-stretch: normal;
}

.tk-poster-gothic-round-cond-atf {
  font-family: "poster-gothic-round-cond-atf", sans-serif;
}
.tk-new-frank {
  font-family: "new-frank", sans-serif;
}

.list-inline {
  @include list-inline;
}

.main-footer {
  position: relative;
  z-index: 1;
  color: #fff;
  transition: transform $transitionSlide;
}

.info-merch {
  background-image: url("../../public/img/bg/merch_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;

  // position: relative;
  .merch-bg {
    width: 100%;
  }
  .merch {
    width: 50%;
  }
  .merch-text {
    color: #333333;
    h3 {
      font-size: 80px;
      font-family: "poster-gothic-round-cond-atf", sans-serif;
      font-weight: 500;
    }
    .divider {
      margin-top: 10px;
      margin-bottom: 10px;
      fill: #d70d11;
    }
    p {
      font-weight: 400;
      display: flex;
      flex-direction: column;
      font-family: "new-frank", sans-serif;
      padding-top: 20px;
      font-size: 17px;
      margin-bottom: 10%;
    }
    .footer-btn-wrapper {
      .hover {
        display: none;
      }
      position: relative;
      &:hover {
        .hover {
          display: block;
          position: absolute;
          width: 100%;
        }
        .btn-background {
          transition: all 0.3s ease-in-out;
        }
        .bi-logo-footer {
          fill: white;
          transition: all 0.3s ease-in-out;
        }
      }
      .btn-background {
        fill: black;
        z-index: 0;
      }
      .bi-logo-footer {
        position: absolute;
        top: 0%;
        left: 25%;
        transform: translate(-15%, -85%);
        fill: white;
      }
    }
  }
  @media screen and (max-width: 1560px) {
    .info-merch {
      height: 40vh;
    }

    .merch-text {
      top: 15%;
      left: 20%;
      color: #333333;
      h3 {
        font-size: 50px;
        font-family: "poster-gothic-round-cond-atf", sans-serif;
        font-weight: 500;
      }
      .divider {
        margin-top: 10px;
        margin-bottom: 10px;
      }
      p {
        font-weight: 400;
        display: flex;
        flex-direction: column;
        font-family: "new-frank", sans-serif;
        padding-top: 20px;
        font-size: 17px;
        margin-bottom: 10%;
      }
      .footer-btn-wrapper {
        position: relative;

        .btn-background {
          fill: black;
          z-index: 0;
        }
        .bi-logo-footer {
          position: absolute;
          top: 0%;
          left: 25%;
          transform: translate(-15%, -85%);
          fill: white;
        }
      }
    }
  }
  @media screen and (max-width: 1300px) {
    .merch-text {
      // width: 100%;
      color: #333333;
      h3 {
        font-size: 50px;
        font-family: "poster-gothic-round-cond-atf", sans-serif;
        font-weight: 500;
      }
      .divider {
        margin-top: 10px;
        margin-bottom: 10px;
      }
      p {
        font-weight: 400;
        display: flex;
        flex-direction: column;
        font-family: "new-frank", sans-serif;
        padding-top: 20px;
        font-size: 17px;
        margin-bottom: 2%;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .info-merch {
    background-color: #c6c7c9;
    height: 350px;
    .merch {
      width: 40%;
    }
  }
}

@media screen and (max-width: 1100px) {
  .info-merch {
    .merch {
      width: 50%;
    }
  }
}

@media screen and (max-width: 770px) {
  .info-merch {
    .merch-text {
      padding-left: 20px;
      color: #333333;
      h3 {
        font-size: 40px;
        font-family: "poster-gothic-round-cond-atf", sans-serif;
        font-weight: 500;
      }
      p {
        font-size: 15px;
        margin-bottom: 30px;
      }
    }
  }
}
.social-form {
  background-color: #262a33;
  display: flex;
  gap: 450px;
  justify-content: center;

  .social {
    // width: 60%;
    display: flex;
    justify-content: center;
    align-items: center;
    h4 {
      font-size: 22px;
      font-family: "new-frank", sans-serif;
      font-weight: 400;
      line-height: 29px;
    }
    .social-icons {
      color: #ffffff;
      display: flex;
      padding-top: 40px;
      gap: 40px;
      width: 80px;
      svg {
        fill: #fff;
      }
    }
  }
  .form {
    padding: 40px;
    .header-text-form {
      font-family: "new-frank", sans-serif;
      h4 {
        font-size: 22px;
        font-weight: normal;
      }
      p {
        font-size: 16px;
        font-weight: normal;
      }
      color: #ffffff;
      font-size: 22px;
      font-weight: 400;
      line-height: 29px;
      margin-bottom: 20px;
    }
    .email {
      width: 100%;
      height: 50px;
      background: #333740 0% 0% no-repeat padding-box;
      opacity: 1;

      border: none;
      padding-left: 20px;
      font-size: 20px;
      font-weight: 600;
      color: #ffffff;
      margin-bottom: 20px;
      &::placeholder {
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
      }
    }
    .terms {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      font-family: "new-frank", sans-serif;

      gap: 10px;
      input {
        font-family: "new-frank", sans-serif;
        width: 20px;
        height: 20px;
        background: #333740 0% 0% no-repeat padding-box;
        border: 1px solid #ffffff;
        border-radius: 5px;
        opacity: 1;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
      }
      a {
        text-decoration: underline;
      }
    }
    .submit {
      gap: 80px;
      display: flex;
      button {
        width: 100%;
        height: 100%;
        z-index: 50;
        position: absolute;
        background: none;
        color: black;
        border: none;
        padding: 0;
        font: inherit;
        cursor: pointer;
        outline: inherit;
      }
      .submit-btn {
        fill: white;
        &:hover {
          fill: #d70d11;
        }
      }
      .submit-wrapper {
        font-family: "new-frank", sans-serif;
        font-size: 20px;
        position: relative;
        .hover {
          display: none;
        }
        &:hover {
          .hover {
            display: block;
            position: absolute;
          }
        }
      }
    }
  }
}

.footer-info {
  padding: 50px 10px 27px;
  background-color: #000;

  &__logos {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__links {
    padding-top: 30px;
    border-top: 1px solid #272727;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    font-family: $metron;
    font-size: 12px;
    color: #888787;

    @media (max-width: $screen-sm-max) {
      display: block;
      text-align: center;
    }
  }

  &__links-list {
    flex: 0 0 auto;
    margin-left: 3em;
    font-family: $sarala;
    text-transform: uppercase;
    color: #666;

    @media (max-width: $screen-sm-max) {
      margin: 1.5em 0 0;
      font-size: 1.2em;
    }

    li {
      &:not(:last-child)::after {
        content: "";
        margin: 0 7px;
        display: inline-block;
        width: 1px;
        height: 0.75em;
        background-color: #666;
      }

      @media (max-width: $screen-xs) {
        display: block;
        line-height: 2;

        &::after {
          display: none !important;
          line-height: 2em;
        }
      }

      a {
        letter-spacing: 0.03em;
        color: inherit;
        text-decoration: none;
        transition: color $linkTransition;

        &:hover {
          color: lighten(#666, 15%);
        }
      }
    }
  }

  &__links-copyright {
    margin: 0;
    letter-spacing: 0.073em;
  }

  &__links-icon {
    margin: 0 0.5em;
  }
}
@media screen and (max-width: 1430px) {
  .social-form {
    gap: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .social-wrapper {
      padding-top: 20px;
      width: 100%;
    }
    .social {
      justify-content: center;
      align-items: center;
      text-align: center;
      .social-icons {
        padding-left: 50%;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

@media screen and (max-width: 700px) {
  .submit {
    label {
      font-size: 10px;
    }
    button {
      font-size: 14px;
      width: 100%;
      height: 100%;
      z-index: 50;
      position: absolute;
      background: none;
      color: black;
      border: none;
      padding: 0;
      cursor: pointer;
      outline: inherit;
    }
    .submit-btn {
      font-size: 12px;
      fill: white;
      &:hover {
        fill: #d70d11;
      }
    }
    .submit-wrapper {
      position: relative;
    }
  }
}
</style>
